// @ts-ignore
import compose from 'koa-compose';
import { request as mockRequest } from './mock';
import { request as requestTimer, response as responseTimer } from './timer';
import { requestPre as requestAdapterPre, requestSet as requestAdapterSet, } from './adapter';
import { request as requestKy } from './ky';
export default function addInterceptors(axios) {
    // 顺序很重要，不能随便改动。因为timer统计里加入了是否使用了bridge的判断。所以requestAdapterPre在最前
    // 插件中的next一定要加await，否则时间统计不准确
    const app = compose([
        requestAdapterPre,
        requestTimer,
        mockRequest,
        requestAdapterSet,
        requestKy,
    ]);
    axios.interceptors.request.use(async (config) => {
        await app(config);
        return config;
    });
    [responseTimer].forEach((interceptor) => {
        axios.interceptors.response.use(...interceptor);
    });
}
